export class CaseAddlProcedureInfoModel {
  CaseAddlProccharInfoId: number;
  CaseId: number;
  FluroPerformedType: string;
  TotalContrastVolumeVal: number;
  TotalContrastVolumePerKg: number;  
  PreCathHemoglobinVal: number;
  Updatedby: string;
}
